import React from 'react';

const Footer = () => {
  return (
    <footer>App created with React by <a href="https://github.com/sorayav" target="_blank" title="Soraya Valle Github" rel="noopener noreferrer">Soraya Valle</a></footer>
  ) 
}

export default Footer;